/*
 * WHICH COMPETITION IS WHICH (organiser, 21 and 31 Oct 2026: «змагання можуть
 * називатися однаково, але в них різні дати проведення … одні можуть в
 * Черкасах бути, а інші в Києві»). A title alone does not tell them apart;
 * wherever a competition is named, its dates and town go beside it — through
 * these, so every screen says it the same way.
 */

// «16.11.2026» — the date as the server keeps it, no time zone shift.
const day = iso => (iso ? String(iso).slice(0, 10).split('-').reverse().join('.') : null);

/** «16.11 – 18.11.2026», or one day «30.09.2023»; null without a start. */
export const competitionDates = (start, end) => {
    const from = day(start);
    const to = day(end);
    if (!from) {
        return null;
    }

    return to && to !== from ? `${from.slice(0, 5)} – ${to}` : from;
};

/**
 * «16.11 – 18.11.2026 · Черкаси · MSAC» — what is known of the dates, the
 * town and the federation. Reads a competition (`locationTitle`,
 * `discipline.code`) or a grant's target (`disciplineCode`).
 */
export const competitionWhenWhere = (competition = {}) => [
    competitionDates(competition.startDate, competition.endDate),
    competition.locationTitle,
    competition.disciplineCode || (competition.discipline && competition.discipline.code),
].filter(Boolean).join(' · ');
